import { PLATFORM_CAPTIONS } from '@/constants';

export default function PlatformIcon({
  platform,
  className = '',
  fontSize = '1.25rem',
  ariaHidden = false,
  variant = 'primary', // 'dark' | 'light' | 'primary'
}) {
  const height = 1.05 * parseFloat(fontSize);

  const platformCaption = PLATFORM_CAPTIONS[platform];

  return (
    <img
      alt={platformCaption}
      className={className}
      aria-hidden={ariaHidden}
      style={{ height: `${height}rem` }}
      src={`/brand/${platform}/icon_${variant}.svg`}
    />
  );
}
